<template>
  <div>
    <div class="d-flex flex-row-column">
      <headnavigation :flow="getFlow" />
      <span class="input-width-330 px-2 r-width-100 d-inline-block ml-auto">
        <md-field>
          <label>Search</label>
          <md-input v-on:keyup="search" v-model="search_term"></md-input>
          <md-icon>search</md-icon>
        </md-field>
      </span>
    </div>
    <hr class="hr-line" />
    <md-table v-if="items.length>0"  v-show="!loading" v-model="items" >
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell md-label="Deposited Date" md-sort-by="date_issued">{{ item.date_issued }}</md-table-cell>
        <md-table-cell md-label="Type" md-sort-by="type">{{item.type}}</md-table-cell>
        <md-table-cell md-label="Status" md-sort-by="status">{{ item.status }}</md-table-cell>

        <md-table-cell md-label="Authorization Code" md-sort-by="auth_code">{{ item.auth_code }}</md-table-cell>
        <md-table-cell md-label="Deposited Amount">{{ item.total_amount }}</md-table-cell>
        <md-table-cell md-label="Bank Account">{{ item.bank_account }}</md-table-cell>
        <md-table-cell md-label="Details">
          <a target="_blank" :href="item.slip_url">View Slip</a>
        </md-table-cell>
      </md-table-row>
    </md-table>

    <pagination
      v-on:change="paginationChange($event)"
      v-on:change_per_page="changePerPage($event)"
      v-if="items.length>0&&pagination"
      :meta="pagination.meta"
      :links="pagination.links"
      :per_page="per_page"
    />

    <empty-state v-if="!loading&&items.length==0" />

    <loading v-if="loading" />
  </div>
</template>
<script>
// import pagination methods paginationChange and changePerPage
import Pagination from "../../../mixins/pagination.js";

// mixin for loading data and state
import DataMixin from "../../../mixins/data.js";

export default {
  mixins: [Pagination, DataMixin],

  data() {
    return {
      search_term: "",
      // url for loading data
      api_url: "/lmt/deposits",
      //IMPORTANT loaded data is stored in items
      items: [],
      myID: auth.getID(),
      flow: [
        { text: "Make a Deposit", link: "/lmt/deposit/create" },
        { text: "History of Slips" }
      ]
    };
  },
  created() {
    this.loadData();
  },
  computed: {
    getFlow() {
      return this.flow;
    }
  }
};
</script>